module.exports = __webpack_public_path__ + "static/img/4-2-aftersale-query.d910f8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/4-2-aftersale-query.png
// module id = 1341
// module chunks = 0